import {styled} from "@mui/material/styles"
import {breakpoints} from "@next/ux-fabric"

type CatalogueContainer = {
    hasMissions: boolean
    hasBanner: boolean
}
export const CatalogueContainer = styled("section", {
    shouldForwardProp: prop => prop !== "hasMissions" && prop !== "hasBanner",
})<CatalogueContainer>`
    width: 100%;
    height: 100%;
    display: block;
    padding-bottom: ${({hasMissions}) => (hasMissions ? 0 : "3rem")};
    margin-bottom: ${({hasBanner}) => (hasBanner ? "3rem" : 0)};

    > div {
        overflow-y: hidden;
    }

    @media (min-width: ${breakpoints.values.md}px) {
        padding: 0 0 3rem 0;
        margin-bottom: 0;

        > div {
            overflow-y: auto;
        }
    }
    @media (min-width: ${breakpoints.values.lg}px) {
        padding-bottom: 0;
    }
`
